import React, { useEffect } from 'react';
import { SecureRoute, useOktaAuth } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from './router';
import { getAppsFromAccessToken } from '../okta';

const AuthenticatedRoute = (props) => {
  const { push: navigate } = useHistory();
  const { authState } = useOktaAuth();

  useEffect(() => {
    // Navigate to login, if user is unauthenticated
    const accessToken = authState.accessToken;
    if (!authState.isAuthenticated || !accessToken) {
      navigate(ROUTES.ROOT);
      return;
    }

    // Navigate to the App Switcher, if user is already authenticated
    const apps = getAppsFromAccessToken(accessToken);
    if (apps.length > 0) {
      navigate(ROUTES.APP_SWITCHER, { apps });
      return;
    }
  }, [authState, navigate]);

  return <props.component />;
};

const AuthenticatedRouteWrapper = (props) => {
  return (
    <SecureRoute
      path={props.path}
      render={() => {
        return <AuthenticatedRoute {...props} />;
      }}
    />
  );
};

export default AuthenticatedRouteWrapper;
